/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionEmailBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation update
   */
  static readonly UpdatePath = '/api/subscription/update-email';

  /**
   * Sends an update request to back office users to implement changes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  update$Plain$Response(params?: {
    body?: {

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionEmailBackendService.UpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Sends an update request to back office users to implement changes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `update$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  update$Plain(params?: {
    body?: {

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.update$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Sends an update request to back office users to implement changes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  update$Json$Response(params?: {
    body?: {

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionEmailBackendService.UpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Sends an update request to back office users to implement changes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `update$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  update$Json(params?: {
    body?: {

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.update$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
